import { BasicRequest } from "./basicRequest";

export class RestoreFileRequest extends BasicRequest{

    public moovFileId!:number;
    public moovStepInstanceId!:number;

    constructor(){
        super();
    }
}